import { useSyncExternalStore } from 'react';

import { cookieUtils } from '@app/app/cookie';
import { COOKIE_KEY } from '@app/app/cookie/cookies-keys';

const DEFAULT_PROJECT_NAME = '';

function getProjectName(): string {
  if (typeof window === 'undefined') {
    return DEFAULT_PROJECT_NAME;
  }
  return cookieUtils.get(COOKIE_KEY.projectName) || DEFAULT_PROJECT_NAME;
}

function subscribe(callback: () => void) {
  return cookieUtils.subscribe((key) => {
    if (key === COOKIE_KEY.projectName) {
      callback();
    }
  });
}

export function useProjectName(): string {
  return useSyncExternalStore(subscribe, getProjectName, getProjectName);
}
